import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { slideToggle } from '../../../helpers/slidetoggle';
import { EditCimEquipment } from '../../../models/cim-equipment.model';
import { EquipmentListService } from '../../../services/equipment-list.service';
import { CimClass } from '../../../models/network-structure.model';
import { TaggedSubstationService } from '../../../services/tagged-substation.service';
import { ToastrService } from 'ngx-toastr';
import { AttributeValue, SectionInstance } from '../../../models/section-definition.model';

@Component({
  selector: 'lib-edit-cim-equipment',
  standalone: false,
  templateUrl: './edit-cim-equipment.component.html',
  styleUrl: './edit-cim-equipment.component.scss',
  animations: [slideToggle],
})
export class EditCimEquipmentComponent {
  selectedEquipment: EditCimEquipment | undefined;
  title: string = '';
  networkCardExpanded: boolean = true;
  userActionsCardExpanded: boolean = true;
  isMapVisible: boolean = false;

  mrid: string = '';
  cimClass: number | undefined = undefined;
  sectionInstances: SectionInstance[] = [];

  constructor(
      private toastr: ToastrService,
      private taggedSubstationService: TaggedSubstationService,
      private location: Location,
      private route: ActivatedRoute,
      private equipmentService: EquipmentListService
    ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.cimClass = Number(params['cimClass']) || undefined;
      this.mrid = params['guid'];
      this.title = CimClass[this.cimClass!]
       let obj = {
          guid: this.mrid,
          cimClass: this.cimClass,
        };
      this.getEquipmentByGuidAndCimClass(obj);
    });
  }

  getEquipmentByGuidAndCimClass(dataIn: any){
    this.equipmentService.getByGuid(dataIn).subscribe({
      next: (response) => {
        this.selectedEquipment = response.body!.data;
        this.getEquipmentInstances();
      }      
    });
  }

  getEquipmentInstances() {
    this.taggedSubstationService
      .getEquipmentInstancesForAsset(
        this.mrid,
        this.selectedEquipment?.substationTemplateId,
        this.cimClass
      )
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.sectionInstances = (responseData.data?.sectionInstances ?? []).map(
              (section: any) => ({
                ...section,
                expanded: true
              })
            );
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: () => {
          this.toastr.error('Error fetching section instances');
        },
      });
  }

  setClickedLocation(attributeValue: AttributeValue | undefined) {
    this.isMapVisible = !this.isMapVisible;
  }

  backClicked(){
    this.location.back();
  }
}
